import React from 'react'
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";
import CalcIcon from "../icon/CalcIcon";

function WorkableIconCalcButton(
    {
        tooltip = Tr('calculate'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={CalcIcon}
        {...props}
    />
}

WorkableIconCalcButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconCalcButton;